export const interp = (p: number, a: number, b: number): number =>
  a * (1 - p) + b * p;

export const easeOutCubic = (x: number): number => 1 - Math.pow(1 - x, 3);

export const isOdd = (value: number): boolean => (value & 1) === 1;

// Snap a mantissa in [1, 10) to the nearest "nice" fraction (1, 2, 5, 10).
const roundedNiceFraction = (f: number): number => {
  if (f < 1.5) return 1;
  if (f < 3) return 2;
  if (f < 7) return 5;
  return 10;
};

// Snap a mantissa in [1, 10) up to the next "nice" fraction (1, 2, 5, 10).
const ceiledNiceFraction = (f: number): number => {
  if (f <= 1) return 1;
  if (f <= 2) return 2;
  if (f <= 5) return 5;
  return 10;
};

export const nicenum = (value: number, round: boolean): number => {
  // log10(0) is -Infinity, which would propagate NaN through the result.
  // Callers pass widths/ranges that can legitimately be 0, for which 0 is the
  // sensible "nice" value.
  if (value === 0) {
    return 0;
  }

  const x = Math.abs(value);
  const exp = Math.floor(Math.log10(x));
  const f = x / Math.pow(10, exp);

  const nf = round ? roundedNiceFraction(f) : ceiledNiceFraction(f);

  return nf * Math.pow(10, exp);
};
